/* eslint-disable import/no-unresolved */
import { initialValues as generalDetailsInitialValues } from "src/helpers/FormDetails/ProposalDetails/GeneralDetails";
import { initialValues as addressDetailsInitialValues } from "src/helpers/FormDetails/ProposalDetails/AddressDetails";
import { initialValues as nomineeDetailsInitialValues } from "src/helpers/FormDetails/ProposalDetails/Nominee";
import { Reducer } from "redux";
import {
  POPULATE_PINOCODE_DATA,
  SET_PROPOSER_DETAILS,
  SAVE_PROPOSER_DETAILS,
  SET_SUB_OCCUPATION_DATA,
  SET_COUNTRY_DATA,
  SET_PROPOSER_REVIEW_DATA,
  SET_PROPOSER_MASTER_DATA
} from "src/redux/Types/proposerDetails";
import { bindProposerReviewData } from "src/helpers/FormDetails";
import { ProposerDetails } from "./interface";

const initialState: ProposerDetails = {
  general: generalDetailsInitialValues,
  address: addressDetailsInitialValues,
  nominee: nomineeDetailsInitialValues,
  pincodeData: {},
  memberId: "",
  applicationId: "",
  subOccupationData: {},
  countryData: {}
};

// eslint-disable-next-line default-param-last
const proposerDetailsReducer: Reducer<ProposerDetails> = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_PROPOSER_DETAILS: {
      // const data = bindProposerAPIData(state, action.payload.apiData, action.payload.masterData);
      const {
        proposerBinding: { obj, memberId },
        leadId
      } = action.payload;
      return {
        ...state,
        ...obj,
        memberId,
        applicationId: leadId
      };
    }
    case SET_PROPOSER_DETAILS: {
      return { ...state, ...action.payload };
    }
    case POPULATE_PINOCODE_DATA: {
      const pincodeResponse = action.payload;
      return { ...state, pincodeData: { [pincodeResponse?.pincode]: pincodeResponse } };
    }
    case SET_SUB_OCCUPATION_DATA: {
      const { payload } = action;
      return { ...state, subOccupationData: { [payload?.code]: payload } };
    }
    case SET_COUNTRY_DATA: {
      const { payload } = action;
      return { ...state, countryData: { [payload?.code]: payload } };
    }
    case SET_PROPOSER_MASTER_DATA: {
      return { ...state, ...action.payload };
    }
    case SET_PROPOSER_REVIEW_DATA: {
      const data = bindProposerReviewData(action.payload);
      return { ...state, ...data };
    }
    default:
      return state;
  }
};

export default proposerDetailsReducer;
